"use client"

import {MutableRefObject, useRef, useState} from "react"
import {useRouter, useSearchParams} from "next/navigation"
import {useForm, Controller} from "react-hook-form"
import {Input} from "@/components/ui/input"
import {SearchIcon} from "lucide-react"
import {StaticWordEnum} from "@/constants/general-enum"
import SearchResult from "@/components/ui/search/search-result"
import useDebounce from "@/hook/useDebounce"
import {DataLayerFactory} from "@/components/google-tag-manager/DataLayerFactory";

interface SearchFormInputs {
    search: string | null
}

export default function SearchHomeInput() {
    const [showResults, setShowResults] = useState<boolean>(false)
    const [searchQuery, setSearchQuery] = useState<string>("")
    const router = useRouter()
    const searchParams = useSearchParams()
    const debouncedSearchQuery = useDebounce(searchQuery, 700)
    const searchInput : MutableRefObject<any>  = useRef(null)

    const {handleSubmit, control, setValue} = useForm<SearchFormInputs>({
        defaultValues: {
            search: searchParams.get("search") || "",
        },
    })

    const searchInputHandler = (values: SearchFormInputs) => {
        if (values.search) {
            setShowResults(false)
            searchInput.current.blur();
            DataLayerFactory.make('search', values.search as string);
            router.push(`/search?search=${encodeURIComponent(values.search as string)}`)
        }
    }


    const showResultsHandler = () => {
        setShowResults(true)
    }

    const closeResultsHandler = () => {
        setShowResults(false)
    }

    const handlePopularSearchClick = (popularSearch: string) => {
        setShowResults(false)
        setSearchQuery(popularSearch)
        setValue("search", popularSearch)
        searchInput.current.blur();
        router.push(`/search?search=${encodeURIComponent(popularSearch as string)}`)
    }

    return (
        <div className="relative w-full">
            {showResults &&
                <div className="fixed inset-0 bg-black bg-opacity-25 -z-50" onClick={closeResultsHandler}></div>}

            <form
                onSubmit={handleSubmit(searchInputHandler)}
                className="w-full max-w-[387px] relative z-40"
            >
                <SearchIcon className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400"/>

                <Controller
                    name="search"
                    control={control}
                    rules={{required: true}}
                    render={({field}: any) => (
                        <Input
                            {...field}
                            ref={searchInput}
                            type="search"
                            autoComplete="off"
                            onFocusCapture={() => showResultsHandler()}
                            placeholder={StaticWordEnum.searchProducts}
                            onChange={(e) => {
                                field.onChange(e)
                                setSearchQuery(e.target.value)
                            }}
                            className="pr-10 pl-4 w-full rounded-[16px] h-[56px] text-[16px] bg-white"
                        />
                    )}
                />

                {showResults &&
                    <SearchResult search={debouncedSearchQuery} onPopularSearchClick={handlePopularSearchClick}/>}
            </form>
        </div>
    )
}

